import React, { useContext, useEffect, useState } from "react";
import { Form, FormControl, FormGroup, Modal } from "react-bootstrap";
import "./Cancel_Reason_Modal.css";
import Blue_Round_Btn from "../../common-btn/blue_round_btn/Blue_Round_Btn";

function Cancel_Reason_Modal(props) {
  const { show, onHide, modal_title, setCancelReasonId } = props;

  const reasons = [
    "Product price has reduced",
    "Wrong contact number entered",
    "Ordered by mistake",
    "Incorrect product size/colour/type ordered",
    "Product price has reduced",
    "Wrong contact number entered",
    "Ordered by mistake",
    "Incorrect product size/colour/type ordered",
  ];

  const data = [
    {
      label: "Frame type",
      value: "Full",
    },
    {
      label: "Shape",
      value: "Cateye",
    },
    {
      label: "Colour",
      value: "Green + Transparent",
    },
    {
      label: "Size",
      value: "55-13-140",
    },
    {
      label: "Material",
      value: "Acetate",
    },
  ];
   const labels = ["Distance Vision (DV)"];
  const headers = ["R-SPH", "R-CYL", "R-AXIS", "R-VA"];
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      className="Cancel_Reason_Modal Modal-holder"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {modal_title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="content_holder">
          <div className="row">
            <div className="col-lg-7 p-1">
              <div className="left_div">
                <div className="text_holder">
                  <p className="odrer_id">Order ID #859647</p>
                  <div className="img_holder">
                    <img
                      src="/assets/images/my_account/orders/img1.png"
                      className="prod_img"
                    />
                  </div>
                  <span className="prod_name">VICTORIA’S SECRET</span>
                </div>

                <div className="outer_box">
                  <div className="all_features_div">
                    {data?.map((item) => {
                      return (
                        <div className="feature_div">
                          <p className="label_text">{item?.label}</p>
                          <p className="value_text">{item?.value}</p>
                        </div>
                      );
                    })}
                  </div>

                  <div className="eye_section">
                    <div className="section_title"></div>

                    {/* Header Row (hide on mobile) */}
                    <div className="row table_header">
                      <div className="col-sm-4 col-4">
                        <p className="eye_spec_title">RIGHT EYE (OD)</p>
                      </div>
                      {headers.map((head, idx) => (
                        <div
                          className="col-2 p-1 text-center header_cell"
                          key={idx}
                        >
                          <p className="top_text">{head}</p>
                        </div>
                      ))}
                    </div>

                    {labels.map((label, rowIdx) => (
                      <div
                        className="row align-items-center table_row"
                        key={rowIdx}
                      >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-4 label_col">
                          <p className="left_text">{label}</p>
                        </div>

                        {headers.map((_, colIdx) => (
                          <div
                            className="col-lg p-1 col-md col-sm-2 col-2 input_col"
                            key={colIdx}
                          >
                            <FormGroup className="input_group">
                              <Form.Control
                                type="text"
                                className="form-control vision-input"
                              />
                            </FormGroup>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 p-1">
              <div className="right_div">
                <div className="select_reason">
                  <Form>
                    {reasons?.map((value, index) => (
                      <Form.Check
                        key={index}
                        label={value}
                        value={value}
                        name="order_cancel_reason_id"
                        type="radio"
                        className="mini-text"
                      />
                    ))}

                    <Form.Group className="input_group">
                      <Form.Control
                        type="text"
                        placeholder="Could you tell us a reason for cancelling? (optional)"
                        as={"textarea"}
                      />
                    </Form.Group>

                    <div className="btn_holder">
                      <Blue_Round_Btn btnText={"Submit"} />
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Cancel_Reason_Modal;
